import ContractDetailsMessageBar from './ContractDetailsMessageBar';

export default ContractDetailsMessageBar;
